import { PaletteMode } from '@mui/material';

const primary = {
  light: '#0089B8',
  main: '#007FAA',
  dark: '#005774',
  contrastText: '#ffffff',
};

const secondary = {
  light: '#E1F9F9',
  main: '#18E3DB',
  dark: '#0B7471',
  contrastText: '#ffffff',
};

const tertiary = {
  main: '#12C5FF',
};

const accent = {
  light: '#FFF4F0',
  main: '#FF6B1B',
  dark: '#C74600',
};

const info = {
  light: '#60ddf0',
  main: '#0097ce',
  dark: '#005894',
  contrastText: '#ffffff',
};

const success = {
  light: '#8cea76',
  main: '#24ba21',
  dark: '#108522',
  contrastText: '#000000',
};

const warning = {
  light: '#f4ce64',
  main: '#dd9504',
  dark: '#9f6002',
  contrastText: '#000000',
};

const error = {
  light: '#f09678',
  main: '#ce3123',
  dark: '#94111c',
  contrastText: '#ffffff',
};

const common = {
  black: '#000000',
  white: '#ffffff',
};

const custom = {
  text: '#424242',
  grey: '#6C6C6C',
  lightGrey: '#AAAAAA',
  divider: '#DCDADA',
  background: '#EBF5F8',
  lightBackground: '#F9F9F9',
  borderColor: '#C4C4C4',
  darkGrey: '#919eab3d',
  info: '#E5F6FD',
  success: '#EDF7ED',
  warning: '#FFF4E5',
  error: '#FDEDED',
  green: '#2E7D32',
  darkGreen: '#1E4620',
  blue: '##0288D1',
  orange: '##EF6C00',
  red: '##D32F2F',
};

const base = {
  primary,
  secondary,
  tertiary,
  error,
  info,
  warning,
  success,
  common,
  accent,
  custom,
};

const palette = {
  ...base,
  mode: 'light' as PaletteMode,
  text: {
    primary: '#424242',
  },
  background: {
    paper: common.white,
    default: common.white,
  },
};

export default palette;
